import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const API_URL = process.env.REACT_APP_API_URL;

const ResetPassword = () => {
  const navigate = useNavigate();
  const [newPassword, setNewPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  //  Şifre kuralları
  const validate = () => {
    if (newPassword.length < 8) return "Şifre en az 8 karakter olmalı.";
    if (newPassword === "Pavza2022*") return "Varsayılan şifre kullanılamaz.";
    if (newPassword !== confirm) return "Şifreler eşleşmiyor.";
    return "";
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const v = validate();
    if (v) return setError(v);

    setError("");
    setLoading(true);

    const token = localStorage.getItem("token");

    if (!token) {
      alert("Oturum süresi dolmuş. Lütfen tekrar giriş yapın.");
      window.location.href = "/auth";
      return;
    }

    try {
      const res = await fetch(`${API_URL}/auth/reset-password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        credentials: "include",
        body: JSON.stringify({ newPassword }),
      });

      if (!res.ok) {
        const j = await res.json().catch(() => ({}));
        throw new Error(j.msg || j.message || "Şifre güncellenemedi.");
      }

      alert("✅ Şifre başarıyla değiştirildi. Lütfen tekrar giriş yapın.");

      //  Tüm verileri temizle (Redux ve token dahil)
      localStorage.clear();
      sessionStorage.clear();

      // navigate yerine tam sayfa yönlendirme
      window.location.href = "/auth";
    } catch (e) {
      console.error("⚠️ Reset password error:", e.message);
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto mt-10 p-6 border rounded">
      <h2 className="text-2xl font-semibold mb-4">Şifre Sıfırlama</h2>

      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label>Yeni Şifre</label>
          <input
            type="password"
            className="w-full border rounded p-2"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            required
          />
        </div>

        <div>
          <label>Yeni Şifre (Tekrar)</label>
          <input
            type="password"
            className="w-full border rounded p-2"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            required
          />
        </div>

        {error && <p className="text-red-500">{error}</p>}

        <button
          type="submit"
          disabled={loading}
          className="w-full bg-blue-600 text-white py-2 rounded"
        >
          {loading ? "Kaydediliyor..." : "Kaydet"}
        </button>
      </form>
    </div>
  );
};

export default ResetPassword;
